<div class="table-component">
  <header>
    <h2 *ngIf="title" class="mt-0">{{title}}</h2>
    <div class="items-header">
      <div class="search" *ngIf="filterField">
        <input id="searchInput" type="text" class="form-control" aria-describedby="basic-addon1" [(ngModel)]="inputFilterData" 
          (ngModelChange)="filterData([{'key': filterField, 'value':inputFilterData,'type': 'string'}])" autocomplete="off">
        <span class="icon-search font-icon"> search </span>
      </div>
      <a class="btn btn-blue-1 new-item" *ngIf="canCreate" routerLink="create">Criar Novo</a>
      <ng-content select="[header-content]" ></ng-content>
      <button class="font-icon btn btn-blue-1" *ngIf="!showFilter && filterForm.length >0" (click)="changeModal(true)">filter_alt</button>
    </div>
  </header>
  <app-filter *ngIf="showFilter"
    [filterData]="filterForm"
    (search)="filterData($event,true)"
    (close)="changeModal(false)"></app-filter>
  <nav class="items-header mb-2">
    <ng-content></ng-content>
    <button  *ngIf="canExport" class="btn btn-blue-1 " (click)="exportData()">Exportar para CSV</button>

  </nav>
  <form [formGroup]="form">
    <table>
      <thead>
        <tr>
          <th *ngIf="hasCheckColumn" class="text-center"> 
            <input type="checkbox" (change)="changeAll($event)">
          </th>
          <ng-container *ngFor="let column of listColumns">
            <th [class]="column.class" [title]="column.title"  *ngIf="!column?.hide">
              {{column.name}}
            </th>
          </ng-container>
          <th *ngIf="hasAction" class="text-center"> Ações </th>
        </tr>
      </thead>
      <tbody formArrayName="data">
        <ng-container *ngFor="let item of filteredListData;let i = index;" [formGroupName]="i">
          <tr [class]="item.class">
            <td *ngIf="hasCheckColumn" class="action-column">
              <input  type="checkbox" formControlName="status">
            </td>
            <ng-container *ngFor="let column of listColumns">
              <td [class]="column.class" [ngClass]="{'inactive-user': item.str_pessoa_ativa == 'N'}"  [ngSwitch]="column.type" *ngIf="!column?.hide">
                <div *ngSwitchCase="'color'" class="field-color" [style]="{backgroundColor:item[column.id]}">
                </div>
                <span *ngSwitchCase="'money'">
                  {{item[column.id] | currency:'BRL':'symbol':'1.2-2'}}
                </span>
                <span *ngSwitchCase="'bool'">
                  {{item[column.id] == true? 'Sim':'Não'}}
                </span>
                <span *ngSwitchDefault>
                  {{ formatValue(item[column.id], column) }}
                </span>
                <ng-container *ngSwitchCase="'input'">
                  <ng-container [ngSwitch]="column.inputType">
                    
                    <input *ngSwitchCase="'money'" [id]="item.key" class="form-control" type="number" 
                      [formControlName]="column.id" (input)="maskMoney(item.key, i, $event)">
                    
                    <input *ngSwitchCase="'integer'" [id]="item.key" class="form-control" type="number" 
                      [formControlName]="column.id" (input)="maskInteger(item.key, i, $event)">
                    
                    <input *ngSwitchDefault class="form-control"  [type]="column.inputType" [formControlName]="column.id"/>
                  </ng-container>
                </ng-container>
                
              </td>
            </ng-container>
            <td *ngIf="hasAction" class="action-column">
              <ng-container *ngFor="let action of listActions">
                <button class="btn btn-font-icon" type="button" (click)="action.func(item)" [title]="action.title">
                  {{action.icon}}
                </button>
              </ng-container>
              <button *ngIf="canEdit(item)" class="btn btn-font-icon" type="button" (click)="navigate(item.id, 'edit')" title="Editar">
                edit
              </button>
              <button *ngIf="canShow(item)" class="btn btn-font-icon" type="button" (click)="navigate(item.id, 'view')" title="Visualizar">
                visibility
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    
  </form>
  <footer *ngIf="canPaginate">
    <mat-paginator
      #paginatorFooter
      (page)="pageChangeEvent($event)"
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [length]="totalRecords"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </footer>
</div>

<app-loading [loader]="isLoading"></app-loading>